<template>
  <div>
    <div v-for="(room, indexRoom) in roomsByBooking.rooms" :key="'room-' + indexRoom" class="booking-room">
      <div class="booking-room-name">
        {{ $t('headers.room') }} {{ room.name }}
      </div>
      <div
        v-for="(guest, indexGuest) in room.guests"
        :key="'room-' + indexRoom + '-guest-' + indexGuest"
        class="checkin-guest mb-4"
      >
        <guest :guest="guest" :isExempt="isExempt(guest)" :status="status(guest.guest.id)" @click="status(guest.guest.id) !== 'COMPLETED' ? goToGuestCheckin(guest.guest.id) : goToGuestCheckinCompleted(guest.guest.id)"/>
      </div>
    </div>
    <div v-if="roomsByBooking.guestsWithoutRoom.length > 0" class="booking-room">
      <div class="booking-room-name">
        {{ $t('headers.without_room')}}
      </div>
      <div
        v-for="(guest, indexGuest) in roomsByBooking.guestsWithoutRoom"
        :key="'room-guest-' + indexGuest"
        class="checkin-guest mb-4"
      >
        <guest :guest="guest" :isExempt="isExempt(guest)" :status="status(guest.guest.id)" @click="status(guest.guest.id) !== 'COMPLETED' ? goToGuestCheckin(guest.guest.id) : goToGuestCheckinCompleted(guest.guest.id)"/>
      </div>
    </div>
  </div>
</template>
<script>
import routeNames from '@/router/routes'
import { mapState, mapGetters } from 'vuex'
export default {
  props: {
    roomsByBooking: Object,
    guestsStatus: Array,
    exempt: Boolean,
  },
  components: {
    Guest: () => import('@/components/view-components/checkin/CheckinGuest.vue'),
  },
  computed: {
    ...mapState(['me']),
    ...mapGetters({
      skipRegisterGuestTypes: 'service/skipRegisterGuestTypeIds',
    }),
  },
  methods: {
    goToGuestCheckin (id) {
      this.$router.push({ name: routeNames.guestcheckin.name, params: { bookingId: this.roomsByBooking.booking.id, guestId: id } })
      window.scrollTo(0, 0)
    },
    goToGuestCheckinCompleted (id) {
      this.$router.push({ name: routeNames.guestcheckincompleted.name, params: { bookingId: this.roomsByBooking.booking.id, guestId: id } })
      window.scrollTo(0, 0)
    },
    status (id) {
      let guestStatus = this.guestsStatus.find(gs => gs.id === id)
      if (guestStatus === undefined) {
        return 'START'
      } else {
        return guestStatus.status
      }
    },
    isExempt ({ guest }) {
      return this.skipRegisterGuestTypes.some((typeId) => guest.typeId === typeId)
    },
  },
}
</script>
<style lang="scss">

.booking-room {
  margin-bottom: 30px;

  .booking-room-name {
    font-size: 20px;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 500;
    margin-bottom: 16px;
  }
}
.checkin-guest {
  border: double 1px transparent;
  background: linear-gradient(white, white), linear-gradient(225deg, var(--v-primary-lighten1), var(--v-primary-darken1));
  background-origin: border-box;
  background-clip: content-box, border-box;
  border-radius: 4px;
  line-height: 32px;

  &:last-child {
    margin-bottom: 0 !important;
  }

  .checkin-guest-content {
    padding: 15px;

    .v-chip {
      float: right !important;
      margin: 0 !important;

      .v-icon {
        margin-left: -5px;
        margin-right: 5px;
      }
    }
  }
}
</style>
